function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M694.86 439.752C672.608 439.752 657.773 423.201 657.773 400.148C657.773 377.095 672.905 360.248 694.86 360.248C716.815 360.248 732.54 377.095 732.54 400.148C732.54 423.201 717.112 439.752 694.86 439.752ZM694.86 503C753.902 503 799 459.258 799 400.148C799 341.037 753.902 297 694.86 297C635.818 297 591.017 340.742 591.017 400.148C591.017 459.554 636.114 503 694.86 503ZM472.339 439.752C450.087 439.752 434.955 423.201 434.955 400.148C434.955 377.095 450.087 360.248 472.339 360.248C494.591 360.248 509.722 377.095 509.722 400.148C509.722 423.201 494.888 439.752 472.339 439.752ZM472.339 503C531.084 503 576.182 459.258 576.479 400.148C576.479 340.742 531.084 297 472.339 297C413.593 297 368.199 340.742 368.199 400.148C368.199 459.554 413.593 503 472.339 503ZM102.063 503C125.205 503 144.194 491.769 158.139 465.169L189.588 406.65V456.303C189.588 485.562 208.577 503 237.95 503C261.092 503 278.003 492.951 294.322 465.169L366.715 343.697C382.44 316.802 371.166 297 336.452 297C317.76 297 305.596 302.911 294.618 323.304L244.773 416.403V333.648C244.773 308.822 232.906 297 211.247 297C193.742 297 180.094 304.389 169.413 325.077L122.535 416.403V334.535C122.535 307.935 111.557 297 85.1515 297H30.8563C10.3843 297 0 306.458 0 323.895C0 341.333 10.9777 351.382 30.8563 351.382H53.1084V456.007C53.1084 485.562 72.987 503 102.063 503Z",
  fill: "#873EFF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 799,
  height: 206,
  fill: "white",
  transform: "translate(0 297)"
})));

var SvgWoocommerce = function SvgWoocommerce(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWoocommerce, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/woocommerce.70aa3ad0.svg";
export { ForwardRef as ReactComponent };